import React, { Component } from 'react'

import css from './style.module.css'
export default class AspectRatio extends Component {

    render() {
        const { children, ratio, background, color, rounded, style, ...props } = this.props
        return (
            <div
                className={[
                            css.container,
                            ratio ? css[`ratio`+ratio] : null,
                            rounded ? css[`rounded`] : null,
                        ].join(' ')}
                style={{
                    ...style,
                    backgroundColor: color ? color : null,
                    backgroundImage: background ? `url(${background})` : null,
                }}
                {...props}
                > 
                <div className={css.text}>{children}</div> 
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/AspectRatio/index.js